import { permissionTypes } from 'src/constants/permissions';
import { hasPermission } from './hasPermission';

export const isAdmin = state => hasPermission(state)(permissionTypes.isAdmin);
